<template>
  <!-- Aviso emergente. HTML + CSS plano (sin v-snackbar) para que funcione igual en Windows 7. -->
  <transition name="ps-toast">
    <div
      v-if="global.notification.show"
      class="ps-toast"
      :style="{ background: global.notification.color, color: textColor }"
      role="status"
      aria-live="polite"
    >
      <i v-if="global.notification.icon" class="mdi ps-toast__icon" :class="global.notification.icon" aria-hidden="true"></i>
      <div class="ps-toast__body">
        <strong>{{ global.notification.title }}</strong>
        <span>{{ global.notification.text }}</span>
      </div>
      <button type="button" class="ps-toast__close" aria-label="Cerrar" @click="global.notification.show = false">
        <i class="mdi mdi-close" aria-hidden="true"></i>
      </button>
    </div>
  </transition>
</template>

<script setup>
import { computed, watch } from "vue";

const global = window.useGlobalStore();

const TIMEOUT = 3500;
let timer = null;

// Se cierra solo a los 3,5 s; si llega otro aviso se reinicia la cuenta.
watch(
  () => global.notification.show,
  (visible) => {
    clearTimeout(timer);
    if (visible) timer = setTimeout(() => (global.notification.show = false), TIMEOUT);
  },
);

// Texto oscuro sobre colores claros (verde, amarillo) y claro sobre oscuros (rojo, azul).
const textColor = computed(() => {
  const hex = (global.notification.color || "").replace("#", "");
  if (hex.length !== 6) return "#1a1a00";
  const [r, g, b] = [0, 2, 4].map((i) => parseInt(hex.slice(i, i + 2), 16));
  return (r * 299 + g * 587 + b * 114) / 1000 > 140 ? "#1a1a00" : "#ffffff";
});
</script>

<style scoped>
.ps-toast {
  position: fixed;
  left: 50%;
  bottom: 24px;
  z-index: 5000;
  display: flex;
  align-items: center;
  gap: 12px;
  box-sizing: border-box;
  width: 420px;
  max-width: calc(100% - 24px);
  padding: 12px 8px 12px 16px;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(26, 26, 0, 0.3);
  transform: translateX(-50%);
}

.ps-toast__icon {
  flex: 0 0 auto;
  font-size: 24px;
}

.ps-toast__body {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-width: 0;
  font-size: 14px;
  line-height: 1.35;
}

.ps-toast__body strong {
  font-family: var(--ps-font-title, "Poppins", Arial, sans-serif);
  font-weight: 700;
}

.ps-toast__close {
  flex: 0 0 auto;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: inherit;
  font-size: 18px;
  cursor: pointer;
}

.ps-toast__close:hover {
  background: rgba(26, 26, 0, 0.12);
}

.ps-toast-enter-active,
.ps-toast-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.ps-toast-enter-from,
.ps-toast-leave-to {
  opacity: 0;
  transform: translate(-50%, 12px);
}
</style>
